/* eslint-disable */
import axios from "axios";
import { toast } from "react-toastify";

export const BASE_URL_GROWTHZILLA = "/growthzilla/remote/public";

export const callApi = async (url, method = "GET", data, headers, params) => {
  const config = {
    method,
    url: BASE_URL_GROWTHZILLA + url,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    data, 
    params,
  };
  return axios(config)
    .then((response) => {
      if (
        response.data?.status === false &&
        response.data?.message === "Please log in to continue."
      ) {
        window.postMessage({ method: "loggedOut" });
      }
     // console.log("response from callapi",response.data)
      return response.data;
    })
    .catch(() => {
      toast.error("Ooops Something went wrong");
    });
};



export const callApiIO =
  process.env.REACT_APP_ENV === "locale" && false
    ? async (url, method = "GET", data, headers, params) => {
      const PORT = process.env.REACT_APP_LOCAL_SERVER_PORT || 4000;
        const searchParams = new URL(`http://localhost:${PORT}` + url)
          .searchParams;
        const dest = searchParams.get("dest") || params?.dest || "";
        return axios({
          method,
          url: `http://localhost:${PORT}/123456/${dest
            .replace(":BID:", 3)
            .replace(":NID:", 3)
            .replace(":UID:", 1)
            .replace(":SID:", 4)
          }`,
          withCredentials: false,
          headers: {
            "Content-Type": "application/json",
            ...headers,
          },
          data,
          params,
        })
          .then((response) => {
            return response.data;
          })
          .catch(() => {
            toast.error("Ooops Something went wrong");
          });
      }
    : callApi;


export const callApiDam = async (
  url,
  method = "GET",
  data,
  headers,
  params
) => {
  const config = {
    method,
    url: BASE_URL_GROWTHZILLA + url,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    data,
    params,
  };
  return axios(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log("error", { error });
      toast.error("Dam server is currently offline !");
    });
};

